"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiBreadcrumbs = void 0;
var palette_1 = require("../../global/palette");
var typography_1 = require("../../global/typography");
exports.MuiBreadcrumbs = {
    li: {
        '& p': __assign({}, typography_1.typography.body2),
        '& a': __assign(__assign({}, typography_1.typography.body2), { color: palette_1.palette.grey[500], '&:visited, &:hover, &:focus, &:active': {
                color: palette_1.palette.grey[500],
            } }),
    },
    separator: {
        marginLeft: 12,
        marginRight: 12,
        color: palette_1.palette.grey[500],
    },
};
